import { makeStyles } from "@material-ui/core";
import {
	DEFAULT_BOX_SHADOW,
	PRIMARY_BACKGROUND,
	instanceVclaim,
} from "App/constants";

export const urlGetSep = "/api/v1/emr/bridging/sep/cari";

export const STYLE_WS_BRIDGING_SEP = makeStyles({
	root: {
		width: "auto",
	},
	paper: {
		width: "100%",
		margin: "0",
		padding: "1rem 1.5rem",
		backgroundColor: PRIMARY_BACKGROUND,
		boxShadow: DEFAULT_BOX_SHADOW,
	},
	table: {
		width: "100%",
		margin: "0 auto",
		overflow: "auto",
	},
});

export const RESET_STATE_SEP = {
	nomor_sep_peserta: "",
};

export const headCells = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "noMr",
		disablePadding: true,
		label: "NO. RM",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "nama",
		disablePadding: true,
		label: "NAMA PASIEN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "tglLahir",
		disablePadding: true,
		label: "TANGGAL LAHIR",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "noSep",
		disablePadding: true,
		label: "NO. SEP",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "noRujukan",
		disablePadding: true,
		label: "NO. RUJUKAN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "poli",
		disablePadding: true,
		label: "Pelayanan",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "tglSep",
		disablePadding: true,
		label: "TGL SEP",
		align: "center",
		minWidth: "100px",
	},
];

export const getSep = async (nomor_sep_peserta) => {
	try {
		const api = await instanceVclaim.post(urlGetSep, {
			nomor_sep_peserta: nomor_sep_peserta,
		});

		const res = api.data;

		return {
			state: true,
			message: res.message,
			data: res?.response,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};